import React, { Component } from "react";
import PropTypes from "prop-types";

export class Toggle extends Component {
  constructor (props) {
    super(props);

    this.state = {
      checked: this.props.checked || false
    };

  }

  render () {
    return (
      <div className={"switch"}>
         <input type={"checkbox"} checked={this.props.checked} onChange={(e)=>{}}/>
        <label onClick={this._clickAction} htmlFor={"switch"} >
         
        </label>
      </div>
    );
  }

  _clickAction = () => {
    let { props } = this;
    if (props.onClick) props.onClick();
        
  };
}

Toggle.defaultProps = {
  checked: false
};

Toggle.propTypes = {
  checked: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};